import NavbarPublico from '../components/NavbarPublico'

function AvisoLegal() {
  return (
    <div style={estilos.pagina}>
      <NavbarPublico
        onIrALogin={() => { window.location.href = '/?login=1' }}
        onIrARegistro={() => { window.location.href = '/?registro=1' }}
        onIrAInicio={() => { window.location.href = '/' }}
        vistaActiva='legal'
      />
      <div style={estilos.contenido}>
        <h1 style={estilos.titulo}>Aviso Legal</h1>
        <p style={estilos.fecha}>Última actualización: 13 de abril de 2026</p>

        <h2 style={estilos.h2}>1. Datos identificativos</h2>
        <p style={estilos.texto}>En cumplimiento del artículo 10 de la Ley 34/2002, de Servicios de la Sociedad de la Información y Comercio Electrónico (LSSI-CE):</p>
        <ul style={estilos.lista}>
          <li><strong>Titular:</strong> Melina Rivera</li>
          <li><strong>Domicilio:</strong> Madrid, España</li>
          <li><strong>Actividad:</strong> Servicios de organización de información personal y legado digital (actividad económica en proceso de alta como autónoma)</li>
          <li><strong>Web:</strong> etern-me.com</li>
          <li><strong>Contacto:</strong> A través del formulario en etern-me.com</li>
        </ul>

        <h2 style={estilos.h2}>2. Objeto del servicio</h2>
        <p style={estilos.texto}>ETERN-ME es una plataforma de organización personal que permite a los usuarios guardar y gestionar información importante de forma segura y privada. El servicio no tiene carácter jurídico ni sustituye a ningún instrumento legal (testamento, poder notarial, etc.).</p>

        <h2 style={estilos.h2}>3. Propiedad intelectual e industrial</h2>
        <p style={estilos.texto}>Todos los contenidos de etern-me.com — textos, imágenes, logotipos, diseño, código fuente y marca — son propiedad de Melina Rivera y están protegidos por la legislación española e internacional sobre propiedad intelectual e industrial.</p>
        <p style={estilos.texto}>Queda prohibida la reproducción, distribución, transformación o comunicación pública de cualquier contenido sin autorización expresa y por escrito del titular.</p>
        <p style={estilos.texto}>El usuario conserva la propiedad intelectual de todos los contenidos que introduce en la plataforma (textos, archivos, mensajes). ETERN-ME no reclama ningún derecho sobre ellos.</p>

        <h2 style={estilos.h2}>4. Responsabilidad</h2>
        <p style={estilos.texto}>ETERN-ME no se responsabiliza de daños derivados del uso incorrecto del servicio, interrupciones técnicas de proveedores terceros, ni de contenidos de sitios externos enlazados. El usuario es responsable de la veracidad y exactitud de la información que introduce.</p>

        <h2 style={estilos.h2}>5. Marco legal de legado digital</h2>
        <p style={estilos.texto}>ETERN-ME opera en conformidad con el artículo 3 de la Ley Orgánica 3/2018 de Protección de Datos Personales y Garantía de los Derechos Digitales (LOPDGDD), que reconoce el derecho de personas vinculadas por razones familiares o de hecho a gestionar los datos digitales de personas fallecidas. El servicio facilita el ejercicio de este derecho mediante la designación de contactos de confianza y herederos digitales por parte del propio usuario.</p>
        <p style={estilos.texto}>La información organizada en ETERN-ME puede servir como complemento informativo a un testamento notarial, pero no tiene por sí sola valor jurídico testamentario conforme al Código Civil español.</p>

        <h2 style={estilos.h2}>6. Eliminación de datos y derecho al olvido</h2>
        <p style={estilos.texto}>Conforme al artículo 17 del RGPD, el usuario puede solicitar la eliminación completa de todos sus datos en cualquier momento desde su cuenta. Los datos se eliminan permanentemente en un plazo máximo de 30 días desde la solicitud.</p>

        <h2 style={estilos.h2}>7. Legislación aplicable</h2>
        <p style={estilos.texto}>Este aviso se rige por la LSSI-CE, el Reglamento General de Protección de Datos (RGPD 2016/679), la LOPDGDD y demás legislación española aplicable. Para cualquier controversia, las partes se someten a los juzgados de Madrid, sin perjuicio de los derechos del consumidor conforme a la normativa europea.</p>
      </div>
      <footer style={estilos.footer}>
        <div style={estilos.footerContenido}>
          <p style={estilos.footerCopy}>2026 ETERN-ME · Todos los derechos reservados · Creado por Melina Rivera</p>
          <div style={estilos.footerLinks}>
            <a href="/privacidad" style={estilos.footerLink}>Privacidad</a>
            <a href="/terminos" style={estilos.footerLink}>Términos</a>
            <a href="/aviso-legal" style={estilos.footerLink}>Aviso Legal</a>
          </div>
        </div>
      </footer>
    </div>
  )
}

const estilos = {
  pagina: { minHeight: '100vh', backgroundColor: '#FAF8F5', display: 'flex', flexDirection: 'column' },
  contenido: { maxWidth: '760px', margin: '0 auto', padding: '48px 24px', flex: 1 },
  titulo: { fontSize: '32px', fontWeight: '800', color: '#2C1810', marginBottom: '8px', letterSpacing: '-0.5px' },
  fecha: { fontSize: '13px', color: '#8B6F47', marginBottom: '40px' },
  h2: { fontSize: '18px', fontWeight: '700', color: '#2C1810', marginTop: '32px', marginBottom: '12px' },
  texto: { fontSize: '15px', color: '#5C4033', lineHeight: '1.8', marginBottom: '12px' },
  lista: { fontSize: '15px', color: '#5C4033', lineHeight: '1.8', paddingLeft: '24px', marginBottom: '12px' },
  footer: { backgroundColor: '#2C1810', padding: '24px 32px' },
  footerContenido: { maxWidth: '1100px', margin: '0 auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '12px' },
  footerCopy: { color: '#ac9370', fontSize: '13px' },
  footerLinks: { display: 'flex', gap: '20px' },
  footerLink: { color: '#C4A882', fontSize: '13px', textDecoration: 'none' },
}

export default AvisoLegal